// extracted by mini-css-extract-plugin
module.exports = {"loading":"initLoading_loading__2ijut","imgWrap":"initLoading_imgWrap__3cMzx"};